import React, { useState } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const Step = ({ number, label, active, onClick, disabled }) => {
  return (
    <FlexContainer
      className={'flex-column align-items-center pointer'}
      style={{
        minWidth: 80,
      }}
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
    >
      <FlexContainer
        className={'width-26px height-26px align-items-center justify-center text-12 index-2'}
        style={{
          borderRadius: '50%',
          background: active ? '#6f8ec0' : '#ffffff',
          border: active ? '3px solid #6f8ec0' : '3px solid #6f8ec0',
          boxShadow: active ? '0 2px 6px rgba(87,180,62,0.25)' : 'none',
          color: active ? '#fff' : '#000001',
          fontWeight: 800,
        }}
      >
        {number}
      </FlexContainer>

      <Label
        className={'text-10 margt4 text-center width-180px'}
        style={{
          color: '#53595f',
          fontWeight: '700',
        }}
      >
        {label}
      </Label>
    </FlexContainer>
  );
};

const AgendaCitaMedicoModal = ({
  open,
  onClose,
  goStep1,
  goStep4,
  goStep3,
  filteredDoctorList,
  listaEspecialidades,
  changueEspFilter,
  selectedSpeciality,
  changeDoctorFilter,
  currentStep,
  setCurrentStep,
  isLoadingDoctor,
  setIsLoadingDoctor,
}) => {
  const [activeTab, setActiveTab] = useState('medicos');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDoctorListBySearch = filteredDoctorList.filter((doc) =>
    doc?.nombres?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  if (!open) return null;

  const setDoctorFromBoxes = (doctor) => {
    setIsLoadingDoctor(true);
    console.log('ver doctor: ', doctor);
    const codigo = doctor.codigo;
    changeDoctorFilter(codigo);
    goStep3();
    setCurrentStep(3);
  };

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column width-940px height-600px padtb26 padlr80 m-padlr0 m-margt30"
        style={{
          borderRadius: '6px 6px 6px 6px',
          boxShadow: '0px 8px 22px rgba(0,0,0,0.15)',
          background: '#ffffff',
          transform: window.innerWidth > 1024 ? 'scale(0.78)' : 'none',
          transformOrigin: 'center',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs pointer top16 right16 width-38px height-38px text-22 align-center justify-center fontWhite"
          style={{
            background: '#023B7A',
            borderRadius: '50%',
            fontWeight: 'bold',
            boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div className="width100 height-550px m-height-650px m-format90 margt30 bgWhite borderrad20 padtb16 padlr10 pos-rel margb20">
          <FlexContainer className="padlr60 width100 margb8">
            <FlexContainer className="align-items-center pos-rel">
              <FlexContainer
                className="pos-abs left80 right80 top12 height-2px borderrad4 index-1"
                style={{
                  background: '#6f8ec0',
                }}
              />

              <FlexContainer className="justify-between width100 index-2 m-hide">
                <Step
                  number={1}
                  label={'Especialidad'}
                  active={currentStep === 1}
                  onClick={goStep1}
                  disabled={false}
                />
                <Step
                  number={2}
                  label={'Médico'}
                  active={currentStep === 2}
                  onClick={() => setCurrentStep(2)}
                  disabled={false}
                />
                <Step
                  number={3}
                  label={'Fecha y Hora Disponibles'}
                  active={currentStep === 3}
                  onClick={goStep3}
                  disabled={currentStep < 3}
                />
                <Step
                  number={4}
                  label={'Confirmar Reserva de Cita'}
                  active={currentStep === 4}
                  onClick={goStep4}
                  disabled={currentStep < 4}
                />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className={'align-center gap-10 padtb0 margb8'}>
            <FlexContainer
              className="align-center width-24px height-24px justify-center pointer"
              style={{ borderRadius: '50%', border: '2px solid #6f8ec0' }}
            >
              <span
                className={'text-20 lineHeight-1'}
                style={{ color: '#6f8ec0', fontWeight: 'bold' }}
                onClick={goStep1}
              >
                ‹
              </span>
            </FlexContainer>

            <div className={'text-18'} style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Agenda una cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}> Elige un médico o fecha</span>
            </div>
          </FlexContainer>

          <FlexContainer className="m-flex-column flex-row gap-16 margt4 width100">
            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
              >
                <option>Miraflores</option>
              </select>

              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>

            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
                onChange={(e) => changueEspFilter(e.target.value, true)}
                value={selectedSpeciality}
              >
                <option value="TODAS">Todas las especialidades</option>
                {listaEspecialidades?.map((esp, i) => (
                  <option key={i} value={esp}>
                    {esp}
                  </option>
                ))}
              </select>
              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="flex-row width100 margt16">
            <FlexContainer
              className="flex-1 justify-center pointer padtb6"
              style={{
                borderBottom: activeTab === 'medicos' ? '3px solid #023B7A' : '1px solid #ccc',
              }}
              onClick={() => setActiveTab('medicos')}
            >
              <Label
                className="text-14 fontBold"
                style={{ color: activeTab === 'medicos' ? '#023B7A' : '#888' }}
              >
                Médicos
              </Label>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="flex-1 align-items-center margt12 pos-rel padlr20">
            <i
              className="fas fa-search pos-abs left30 text-16"
              style={{
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#144696',
              }}
            ></i>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={activeTab === 'medicos' ? 'Busca tu médico' : 'Busca fecha disponible'}
              className="width100 height-22px padtb8 padr12 padl36 borderrad4 text-14 outlineNone bgWhite"
              style={{
                border: '1px solid #C9C9C9',
                fontWeight: 500,
              }}
            />
          </FlexContainer>

          <FlexContainer className="my-custom-scroll margt16 width100 height-300px m-height-230px overflowY padr0 pos-rel padb16">
            {activeTab === 'medicos' && (
              <>
                {searchTerm === '' && (
                  <FlexContainer
                    className={window.innerWidth > 1024 ?  "grid width100" : 'm-flex-column width100'}
                    style={{
                      gridTemplateColumns: window.innerWidth > 1024 ? 'repeat(2, 1fr)' : 'none',
                      gap: '20px',
                      padding: '12px 40px',
                    }}
                  >
                    {filteredDoctorList.map((doc, i) => (
                      <FlexContainer
                        key={i}
                        className="height-100px m-height-150px flex-row align-center pointer borderrad16 bgWhite"
                        onClick={() => setDoctorFromBoxes(doc)}
                        style={{
                          padding: '18px 20px',
                          minHeight: 90,
                          border: '1px solid #EAEAEA',
                          boxShadow: '0px 4px 14px rgba(0,0,0,0.10)',
                          transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                          gap: '14px',
                        }}
                      >
                        <FlexContainer
                          className="justify-center align-center padt16"
                          style={{ width: 56, height: 56 }}
                        >
                          <img
                            src={'/doctors/' + doc?.imagen}
                            alt="doctor"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </FlexContainer>

                        <FlexContainer className="flex-column justify-center" style={{ flex: 1 }}>
                          <Label className="text-20 m-text-12" style={{ color: '#023B7A', lineHeight: 1.1 }}>
                            <strong> {doc.nombres}</strong>
                          </Label>
                          <Label className="text-16 m-text-10" style={{ color: '#6B6B6B', marginTop: 4 }}>
                            {doc.especialidad}
                          </Label>
                        </FlexContainer>
                      </FlexContainer>
                    ))}
                  </FlexContainer>
                )}
                {searchTerm !== '' && (
                  <FlexContainer
                    className="grid width100"
                    style={{
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '20px',
                      padding: '12px 40px',
                    }}
                  >
                    {filteredDoctorListBySearch.map((doc, i) => (
                      <FlexContainer
                        key={i}
                        onClick={() => setDoctorFromBoxes(doc)}
                        className="height-100px flex-row align-center pointer borderrad16 bgWhite"
                        style={{
                          padding: '18px 20px',
                          minHeight: 90,
                          border: '1px solid #EAEAEA',
                          boxShadow: '0px 4px 14px rgba(0,0,0,0.10)',
                          transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                          gap: '14px',
                        }}
                      >
                        <FlexContainer
                          className="justify-center align-center padt16"
                          style={{ width: 56, height: 56 }}
                        >
                          <img
                            src={'/doctors/' + doc?.imagen}
                            alt="doctor"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </FlexContainer>

                        <FlexContainer className="flex-column justify-center" style={{ flex: 1 }}>
                          <Label className="text-20 " style={{ color: '#023B7A', lineHeight: 1.1 }}>
                            <strong> {doc.nombres}</strong>
                          </Label>
                          <Label className="text-16" style={{ color: '#6B6B6B', marginTop: 4 }}>
                            {doc.especialidad}
                          </Label>
                        </FlexContainer>
                      </FlexContainer>
                    ))}
                  </FlexContainer>
                )}
              </>
            )}
          </FlexContainer>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AgendaCitaMedicoModal;
